import React, { useState, useEffect } from 'react';

import { SiteReg } from './SiteReg';
import { SuccessReg } from './SuccessReg';
import { CourseReg } from './CourseReg';
import { CourseRegFree } from './CourseRegFree';
import { ProgressBar } from '~c/ui/ProgressBar';
import { EducationData } from './EducationData';

import {
  checkIsAuthed,
  unescapeUserData,
  eventTypes,
  decodeWindowUser,
  sentUsersBrowserData
} from './utils';

export const EventReg = props => {
  
  const { eventType, eventCode, pageCode } = props;

  const [user, setUser] = useState(
    checkIsAuthed() ? decodeWindowUser(unescapeUserData([window.user])[0]) : null,
  );

  const [stagesList, setStagesList] = useState([]);
  const [currentStage, setCurrentStage] = useState(1);
  const [stagesCount, setStagesCount] = useState(0);
  const [dataForEduServices, setDataForEduServices] = useState([]);
  const [checkSubscribe, setCheckSubscribe] = useState(false);
  const [fillLater, setFillLater] = useState(false);

  const nextStep = () => {
    setCurrentStage(currentStage + 1);
  };

  const changeDataForEduServices = (data) => setDataForEduServices(data);
  const changeCheckSubscribe = (bool) => setCheckSubscribe(bool);
  const getStagesByType = (type) => {
    let siteReg;
    let stages = [];

    switch (type) {
      case eventTypes.FREE:
        siteReg = <SiteReg
          type="person"
          allowChangeType={false}
          isCompanyReg
          onComplete={nextStep}
          onCheckSubscribe={changeCheckSubscribe}
          onAuth={() => window.location.reload()}
          setUser={setUser}
        />;
        stages = [
          <CourseRegFree
            nextStep={nextStep}
            eventCode={eventCode}
            pageCode={pageCode}
            user={user}
            checkSubscribe={checkSubscribe}
            eventTypes={eventTypes.FREE}
          />,
          <SuccessReg />
        ];
        break;
      case eventTypes.CONSULT:
        siteReg = <SiteReg
          allowChangeType
          isCompanyReg={false}
          onComplete={nextStep}
          onCheckSubscribe={changeCheckSubscribe}
          onAuth={() => window.location.reload()}
          setUser={setUser}
        />;
        stages = [
          <CourseReg
            nextStep={nextStep}
            eventCode={eventCode}
            pageCode={pageCode}
            user={user}
            setUser={setUser}
            checkSubscribe={checkSubscribe}
            currentStage={currentStage}
            eventTypes={eventTypes.CONSULT}
            sendUsersData={sentUsersBrowserData}
          />,
          <SuccessReg />
        ];
        break;
      case eventTypes.EDU:
        setFillLater(true);
        siteReg = <SiteReg
          allowChangeType
          isCompanyReg={false}
          onComplete={nextStep}
          onCheckSubscribe={changeCheckSubscribe}
          onAuth={() => window.location.reload()}
          setUser={setUser}
        />;
        stages = [
          <CourseReg
            nextStep={nextStep}
            eventCode={eventCode}
            pageCode={pageCode}
            user={user}
            setUser={setUser}
            checkSubscribe={checkSubscribe}
            currentStage={currentStage}
            eventTypes={eventTypes.EDU}
            cbDataForEduServices={changeDataForEduServices}
            sendUsersData={sentUsersBrowserData}
          />,
          <EducationData
            nextStep={nextStep}
            dataForEduServices={dataForEduServices}
            setFillLater={setFillLater}
          />,
          <SuccessReg fillLater={fillLater}/>
        ];
        break;
      default:
        // eslint-disable-next-line no-console
        console.error('invalid event type');
    }

    return checkIsAuthed() ? stages : [siteReg, ...stages];
  };

  const setStages = () => {
    const stages = getStagesByType(eventType);

    setStagesCount(stages.length);
    setStagesList(stages);
    return stages;
  };

  useEffect(() => {
    setStages();
  }, [user, currentStage]);

  return (
      <div className="registration-course registration-container">
        <ProgressBar className="registration-course__progress-bar" currentStage={currentStage} stagesCount={stagesCount} />
        {stagesList[currentStage - 1]}
      </div>
  );
};